/**
 * Where a 401 goes.
 *
 * Any request can be the one that discovers the session has gone — a poll, a save, the stream a
 * reply is arriving over — and the answer is the same in every case: show the login view. Handling
 * it at each call site would mean every future call site having to remember to, so the API layer
 * reports it once and the app decides what to do about it.
 *
 * Its own module rather than a field of the client, so the transport can report one without
 * importing the client's request helper.
 */
type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | undefined;

/** Registered by the app shell; the last registration wins, and there is only ever one shell. */
export const onUnauthorized = (next: UnauthorizedHandler): (() => void) => {
  handler = next;

  return () => {
    if (handler === next) {
      handler = undefined;
    }
  };
};

export const reportUnauthorized = (status: number): void => {
  if (status === 401) {
    handler?.();
  }
};
